var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      directives: [{ name: "tooltip", rawName: "v-tooltip" }],
      ref: "addToWishList",
      staticClass: "btn btn-link btn-sm text-muted btn-wishlist",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "top",
        title: _vm.tooltipText,
      },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.switchState()
        },
      },
    },
    [
      _vm.styleType === 2
        ? _c("icon", {
            staticClass: "default-float",
            class: { "text-appearance text-danger": _vm.isVariationInWishList },
            attrs: { icon: "heart", loading: _vm.isLoading },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.styleType === 1
        ? [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$translate("Ceres::Template.singleItemWishList")) +
                "\n    "
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.styleType === 3
        ? [_vm._v("\n        " + _vm._s(_vm.tooltipText) + "\n    ")]
        : _vm._e(),
      _vm._v(" "),
      _vm.styleType === 4 && !_vm.isVariationInWishList
        ? [
            _c("div", { staticClass: "standard" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "64",
                    height: "64",
                    viewBox: "0 0 64 64",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      id: "heart-line",
                      d: "M19.142,34.491a1.071,1.071,0,0,1-.654-.225C12.532,29.638,8.428,25.652,5.557,21.72,1.893,16.7,1.057,12.056,3.071,7.931,4.507,4.985,8.632,2.574,13.453,3.977a10.575,10.575,0,0,1,5.689,4.039,10.575,10.575,0,0,1,5.689-4.039C29.642,2.6,33.778,4.985,35.214,7.931c2.014,4.125,1.179,8.764-2.486,13.789-2.871,3.932-6.975,7.918-12.932,12.546A1.071,1.071,0,0,1,19.142,34.491ZM10.71,5.724A6.321,6.321,0,0,0,5,8.863c-1.661,3.407-.911,7.2,2.293,11.582a61.21,61.21,0,0,0,11.85,11.614,61.21,61.21,0,0,0,11.85-11.6c3.214-4.393,3.954-8.186,2.293-11.582C32.214,6.731,29,5.027,25.421,6.034a8.571,8.571,0,0,0-5.293,4.5,1.071,1.071,0,0,1-1.982,0,8.5,8.5,0,0,0-5.293-4.5A7.832,7.832,0,0,0,10.71,5.724Z",
                      transform: "translate(12.857 14.979)",
                      fill: "#707070",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Ellipse_14",
                        "data-name": "Ellipse 14",
                        fill: "none",
                        stroke: "#707070",
                        "stroke-width": "2",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: { cx: "32", cy: "32", r: "32", stroke: "none" },
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        attrs: { cx: "32", cy: "32", r: "31", fill: "none" },
                      }),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "hover" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "64",
                    height: "64",
                    viewBox: "0 0 64 64",
                  },
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Ellipse_23",
                        "data-name": "Ellipse 23",
                        fill: "#fff",
                        stroke: "#3c3c3c",
                        "stroke-width": "2",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: { cx: "32", cy: "32", r: "32", stroke: "none" },
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        attrs: { cx: "32", cy: "32", r: "31", fill: "none" },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      id: "heart-line",
                      d: "M19.142,34.491a1.071,1.071,0,0,1-.654-.225C12.532,29.638,8.428,25.652,5.557,21.72,1.893,16.7,1.057,12.056,3.071,7.931,4.507,4.985,8.632,2.574,13.453,3.977a10.575,10.575,0,0,1,5.689,4.039,10.575,10.575,0,0,1,5.689-4.039C29.642,2.6,33.778,4.985,35.214,7.931c2.014,4.125,1.179,8.764-2.486,13.789-2.871,3.932-6.975,7.918-12.932,12.546A1.071,1.071,0,0,1,19.142,34.491ZM10.71,5.724A6.321,6.321,0,0,0,5,8.863c-1.661,3.407-.911,7.2,2.293,11.582a61.21,61.21,0,0,0,11.85,11.614,61.21,61.21,0,0,0,11.85-11.6c3.214-4.393,3.954-8.186,2.293-11.582C32.214,6.731,29,5.027,25.421,6.034a8.571,8.571,0,0,0-5.293,4.5,1.071,1.071,0,0,1-1.982,0,8.5,8.5,0,0,0-5.293-4.5A7.832,7.832,0,0,0,10.71,5.724Z",
                      transform: "translate(12.857 14.979)",
                      fill: "#3c3c3c",
                      stroke: "#3c3c3c",
                      "stroke-width": "1",
                    },
                  }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "t-small" }, [
              _vm._v(
                _vm._s(_vm.$translate("Ceres::Template.singleItemWishList"))
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.styleType === 4 && _vm.isVariationInWishList
        ? [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "64",
                  height: "64",
                  viewBox: "0 0 64 64",
                },
              },
              [
                _c("path", {
                  attrs: {
                    id: "heart-line",
                    d: "M19.142,34.491a1.071,1.071,0,0,1-.654-.225C12.532,29.638,8.428,25.652,5.557,21.72,1.893,16.7,1.057,12.056,3.071,7.931,4.507,4.985,8.632,2.574,13.453,3.977a10.575,10.575,0,0,1,5.689,4.039,10.575,10.575,0,0,1,5.689-4.039C29.642,2.6,33.778,4.985,35.214,7.931c2.014,4.125,1.179,8.764-2.486,13.789-2.871,3.932-6.975,7.918-12.932,12.546A1.071,1.071,0,0,1,19.142,34.491Z",
                    transform: "translate(12.857 14.979)",
                    fill: "#cd5e5b",
                  },
                }),
                _vm._v(" "),
                _c(
                  "g",
                  {
                    attrs: {
                      id: "Ellipse_26",
                      "data-name": "Ellipse 26",
                      fill: "none",
                      stroke: "#707070",
                      "stroke-width": "2",
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { cx: "32", cy: "32", r: "32", stroke: "none" },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: { cx: "32", cy: "32", r: "31", fill: "none" },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "t-small" }, [
              _vm._v(
                _vm._s(_vm.$translate("Ceres::Template.singleItemWishList"))
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }